<div class="tab-selector font-bold">
  <ng-content></ng-content>
</div>
